import { render, staticRenderFns } from "./CollectionDayGather.vue?vue&type=template&id=5a01f50e&"
import script from "./CollectionDayGather.vue?vue&type=script&lang=js&"
export * from "./CollectionDayGather.vue?vue&type=script&lang=js&"
import style0 from "./CollectionDayGather.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports